module.exports = __webpack_public_path__ + "img/buyers_posting inbox.f21a2cea.svg";